export default "__VITE_ASSET__BNb1iCI6__"